// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
// import "../src/styles/globals.css";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import ShopConfigPage from "./pages/ShopConfigPage";
import MainLayout from "./components/Layout/MainLayout";
import { AuthProvider, useAuth } from "./hooks/useAuth";
import { AppProvider } from "./context/AppContext";
import { Toaster } from "./components/ui/toaster";
import StrategyGeneratorPage from "./pages/StrategyGeneratorPage";
import OnboardingFilesPage from "./pages/OnboardingFilesPage";

// Create .env.local file with:
// REACT_APP_USE_MOCK_DATA=true

function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <MainLayout />
                  </PrivateRoute>
                }
              >
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route
                  path="/shop-configuration"
                  element={<ShopConfigPage />}
                />
                <Route
                  path="/strategy-generator"
                  element={<StrategyGeneratorPage />}
                />
                <Route
                  path="/onboarding-files"
                  element={<OnboardingFilesPage />}
                />
              </Route>
            </Routes>
            <Toaster />
          </div>
        </Router>
      </AppProvider>
    </AuthProvider>
  );
}

function PrivateRoute({ children }) {
  const { token, loading } = useAuth();

  // Show loading indicator while checking authentication
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return token ? children : <Navigate to="/login" replace />;
}

export default App;
